<template>
    <v-dialog v-model="dialog" width="800px">
        <v-card>
            <v-card-title>
                {{hsva.huis_code }} Created:{{hsva.hsva_dt}}
                <v-spacer></v-spacer>
                <v-btn text icon  @click="rmHsva(hsva.hsva_encrid)"><v-icon small>mdi-trash-can-outline</v-icon></v-btn> 
            </v-card-title>
            <p>
                <v-select v-model="hsva.hsva_tonen" :items="hsva_tonenKeuzes" item-value="toon_nr" item-text="toon_oms" label="Publication on"></v-select>
            </p>  
            <div v-for="(hsvataalRecord,i) in hsva.hsvataal" :key="i">
                <hr>  
                <v-row no-gutters>
                    <v-col class="mx-2">
                        <v-textarea v-model="hsvataalRecord.hsvataal_vraag" :value=hsvataalRecord.hsvataal_vraag rows="3" :label=hsvataalRecord.hsvataal_vraag_label counter spellcheck="false"></v-textarea>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col class="mx-2">
                        <v-textarea v-model="hsvataalRecord.hsvataal_antwoord" :value=hsvataalRecord.hsvataal_antwoord rows="3" :label=hsvataalRecord.hsvataal_antwoord_label counter spellcheck="false"></v-textarea>
                    </v-col>
                </v-row>
            </div>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary mx-2" small @click="saveHsva">Save</v-btn>
                <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
            </v-card-actions>
            <rmHsva ref="rmHsva" @reload="reload"></rmHsva>
        </v-card>
    </v-dialog>
</template>

<script>
    import rmHsva from "@/views/huis/hsva/rmHsva.vue";

    export default {
        components: {
            rmHsva
        },
        data() { 
            return {
                dialog: false,
                hsva: {},
                hsva_tonenKeuzes: []
            }
        },
        methods: {
            open(hsva_encrid) {
                var deze = this;
                this.dialog = true;
                this.$axios.post("ares/json/ares/huis/hsva/getHsva.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHsva"
                    },
                    getHsva: {
                        hsva_encrid: hsva_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                    this.hsva = res.data.getHsva;
                    res.data.getHsva.hsva_tonenKeuzes.forEach(function(toon) {
                        deze.hsva_tonenKeuzes.push(toon); 
                    });
                }
            });
        },
        saveHsva() { 
            this.$axios.post("ares/json/ares/huis/hsva/saveHsva.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "saveHsva"
                },
                saveHsva: {
                    hsva_encrid: this.hsva.hsva_encrid,
                    hsva: this.hsva
                }
            }).then(res => {
                if (res.data.error) {
                    console.log(res.data.error);
                } else {          
                    this.$store.dispatch('setSnackbar', {
                        showing: true,
                        text: res.data.saveHsva.text,
                        color: res.data.saveHsva.color
                    }); 
                    this.$emit("reload");
                    this.dialog = false;
                }
            })
        },
        rmHsva(hsva_encrid) {
            this.$refs.rmHsva.open(hsva_encrid);
        },
        reload() {
            // Aangeroepen door remove indien OK, dan dit venster sluiten, en reload op hoofd scherm.
            this.$emit("reload");
            this.dialog = false;
        },
    }
}
</script>
